export const ROUTE_PATH = '/efs-visit-records';

export const FEATURE_NAME = 'efsVisitRecordsPage';
